'use strict';

var cov_13ducq9bh2 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/municipalityDetails/municipalityDetails.js',
        hash = '91fcac34296441839300dc5df4d4e9a9c2a29e0c',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/municipalityDetails/municipalityDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 8,
                    column: 3
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_13ducq9bh2.s[0]++;
angular.module('app').component('municipalityDetails', {
    templateUrl: 'app/components/municipalityDetails/municipalityDetails.html',
    bindings: {
        municipality: '<'
    }
});